import { render, staticRenderFns } from "./TagFeed.vue?vue&type=template&id=4f9ec495&"
import script from "./TagFeed.vue?vue&type=script&lang=js&"
export * from "./TagFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports